module.exports = __webpack_public_path__ + "img/intro_no.57e481c8.svg";